
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AlertCircle, CheckCircle2, Loader2, X } from "lucide-react";

interface VoucherInputProps {
  voucherCode: string;
  setVoucherCode: (code: string) => void;
  validateVoucher: () => Promise<void>;
  clearVoucher: () => void;
  isValidatingVoucher: boolean;
  validVoucher: any;
  voucherError: string | null;
}

const VoucherInput = ({
  voucherCode,
  setVoucherCode,
  validateVoucher,
  clearVoucher,
  isValidatingVoucher,
  validVoucher,
  voucherError
}: VoucherInputProps) => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    validateVoucher();
  };

  // Format discount value based on discount type
  const formatDiscount = () => {
    if (!validVoucher) return "";
    
    return validVoucher.discount.type === "amount" 
      ? `$${(validVoucher.discount.value / 100).toFixed(2)} off`
      : `${validVoucher.discount.value}% off`;
  };

  return (
    <div className="space-y-2">
      <Label htmlFor="voucher-code">Voucher Code</Label>
      
      <form onSubmit={handleSubmit} className="flex space-x-2">
        <div className="relative flex-1">
          <Input
            id="voucher-code"
            placeholder="Enter voucher code"
            value={voucherCode}
            onChange={(e) => setVoucherCode(e.target.value)}
            disabled={isValidatingVoucher || !!validVoucher}
            className={`${voucherError ? 'border-red-500' : ''} ${validVoucher ? 'border-green-500 pr-10' : ''}`}
          />
          {validVoucher && (
            <CheckCircle2 className="absolute right-3 top-1/2 -translate-y-1/2 h-5 w-5 text-green-500" />
          )}
        </div>
        
        {validVoucher ? (
          <Button 
            type="button" 
            variant="outline" 
            onClick={clearVoucher}
            className="shrink-0"
          >
            <X className="h-4 w-4 mr-1" />
            Remove
          </Button>
        ) : (
          <Button 
            type="submit" 
            disabled={isValidatingVoucher || !voucherCode.trim()} 
            className="shrink-0"
          >
            {isValidatingVoucher ? (
              <>
                <Loader2 className="h-4 w-4 mr-1 animate-spin" />
                Validating...
              </>
            ) : (
              'Apply'
            )}
          </Button>
        )}
      </form>
      
      {voucherError && (
        <div className="flex text-sm text-red-500 items-center mt-1">
          <AlertCircle className="h-4 w-4 mr-1" />
          <span>{voucherError}</span>
        </div>
      )}
      
      {validVoucher && (
        <div className="text-sm text-green-600 font-medium">
          Voucher applied: {formatDiscount()}
        </div>
      )}
    </div>
  );
};

export default VoucherInput;
